import {
  ADD_ITEM_TO_ADMIN_TABLE_ITEMS,
  CLEAR_TABLE_QUERY_PARAMS,
  SET_TABLE_DATE_RANGE,
  SET_TABLE_QUERY_PARAMS,
  SET_TABLE_RECORDS,
  SET_TABLE_SEARCH_TERM,
  SET_TABLE_NEEDS_REFRESH,
} from '../../constants/actionConstants';

export const addItemToAdminTableItems = (item: any) => ({
  type: ADD_ITEM_TO_ADMIN_TABLE_ITEMS,
  payload: item,
});

export const setAdminRecord = (data: any) => ({
  type: SET_TABLE_RECORDS,
  payload: { details: data },
});

export const setSearchTerm = (searchTerm: string, source: string) => ({
  type: SET_TABLE_SEARCH_TERM,
  payload: { searchTerm, source },
});

export const setDateRange = (
  startDate: Date,
  endDate: Date,
  source: string,
  maxPast?: Date,
  maxFuture?: Date,
) => ({
  type: SET_TABLE_DATE_RANGE,
  payload: {
    source,
    dateRange: {
      startDate,
      endDate,
      maxPast,
      maxFuture,
    },
  },
});

export const clearSearchTerm = (source: string) => ({
  type: SET_TABLE_SEARCH_TERM,
  payload: { searchTerm: '', source },
});

export const clearDateRange = (source: string) => ({
  type: SET_TABLE_DATE_RANGE,
  payload: { source, dateRange: null },
});

export const setDataTableQueryParams = (queryParams: any, source: string) => ({
  type: SET_TABLE_QUERY_PARAMS,
  payload: { queryParams, source },
});

export const clearDataTableQueryParams = (source: string) => ({
  type: CLEAR_TABLE_QUERY_PARAMS,
  payload: { source },
});

export const addToOrUpdateListInStore = (adminObject: any, destination: string) => ({
  type: destination,
  payload: adminObject.data || adminObject,
});

export const setDataTableNeedsRefresh = (needsRefresh: boolean) => ({
  type: SET_TABLE_NEEDS_REFRESH,
  payload: needsRefresh,
});
